import img1 from '../../assets/price1.svg'
import img3 from '../../assets/price2.svg'
import img2 from '../../assets/price3.svg'

export const priceData = [
    {
        color: 'bg-red-500',
        title: 'Staff/Resource Augmentation',
        img: img1,
        desc: 'Hire top talent at a fraction of the cost',
        points: [
            'Vetted developer profiles in 48 hours',
            'Staffing within 1-2 weeks',
            'Availability of developers in every tech stack',
            'No hiring and retention stress',
            'Management and payroll freedom',
            'Schedule a 7-day trial'
        ],
        Q1: 'How early do you need a developer?',
        ans1: [
            'Within 7 days',
            'Within 2 weeks',
            'In a month',
            'Not sure',
        ],
        Q2: 'For how long?',
        ans2: [
            '1-3 months',
            '3-6 months',
            '6-10 months',
            '10+ months'
        ]
    },
    {
        color: 'bg-gray-800 dark:bg-gray-700',
        title: 'Product Development',
        img: img2,
        desc: 'Get your products built from scratch',
        points: [
            'Expert UI/UX design',
            'Prototype and wireframing',
            'Free dedicated project management',
            'Free dedicated quality assurance',
            'Timely delivery',
            'Weekly sprints',
        ],
        Q1: 'What are you looking to develop?',
        ans1: [
            'MVP',
            'Product Development',
            'UI/UX Design',
            'Working Prototype',
            'Something Else',
        ],
        Q2: 'For which platform?',
        ans2: [
            'Mobile',
            'Desktop',
            'All of them'
        ]
    },
    {
        color: 'bg-yellow-600',
        title: 'Dedicated Team',
        img: img3,
        desc: 'Hire dedicated developers for scalable results',
        points: [
            'Transparent pricing system',
            'Personal extended team working on project',
            'Project manager allocated by CodeZone',
            'Team flexibility and scalability',
            'Direct communication with developers',
            'Extend team according to your requirements',
        ],
        Q1: 'How many developers do you need?',
        ans1: [
            '2-6 developers',
            '6-10 developers',
            '10+ developers'
        ],
        Q2: 'For how long?',
        ans2: [
            '1-3 months',
            '3-6 months',
            '6-10 months',
            '10+ months'
        ]
    },
]